import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link} from 'react-router-dom'


const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

const useStyless = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 4,
    color: '#fff',
  },
}));

export default function MobileSidebar() {

  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  
  const [open, setOpen] = React.useState(false);
  const classess = useStyless();
   const handleLogout = async (e) => {
    e.preventDefault()
    
      setOpen(true)
      
      
      
      setTimeout(async () => {
          // await refresh()
          window.location.reload()
      }, 5000);
      
  }
  const toggleDrawer = (anchor, open) => (event) => {
    // if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
    if (event.key === 'Tab' || event.key === 'Shift') {
      
    return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
       
        <ListItem button key={'Home'}>
          <Link to="/" className="black-text">
            <ListItemText primary={'Home'} />
          </Link>
        </ListItem>
        <ListItem button key={'About'}>
          <Link to="/about" className="black-text">
            <ListItemText primary={'About '} />
          </Link>
        </ListItem>
        <ListItem button key={'blog'} >
          <Link to='/blog'  className="black-text">
            <ListItemText primary={'Blog'} />
          </Link>
        </ListItem>
        <ListItem button key={'My Account'}>
          <Link to="/faqs" className="black-text">
            <ListItemText primary={'Faqs'} />
          </Link>
        </ListItem>
        <ListItem button key={'My Account'}>
          <Link to="/savings-plan" className="black-text">
            <ListItemText primary={'Savings Plan'} />
          </Link>
        </ListItem>
        {/* <ListItem button key={'My Account'}>
          <Link to="/pocket" className="black-text">
            <ListItemText primary={'Purse'} />
          </Link>
        </ListItem> */}
       
        <ListItem button key={'My Account'}>
          <Link to="/terms" className="black-text">
            <ListItemText primary={'Terms & Conditions'} />
          </Link>
        </ListItem>
        <ListItem button key={'My Account'}>
          <Link to="/privacy" className="black-text">
            <ListItemText primary={'Privacy policy'} />
          </Link>
        </ListItem>
        
        
      </List>
      
    </div>
  );

  return (
    <div>
      {['left'].map((anchor) => (
        <React.Fragment key={'left'}>
          <button type="button" className="btn-flat btn black-text center"
            style={{margin:"-20px 10px 0px -30px"}}
            onClick={toggleDrawer('left', true)}><i className="material-icons black-text">menu</i></button>
          <Drawer   anchor={'left'} open={state['left']} onClose={toggleDrawer('left', false)}>
            {list('left')}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
